import { render, staticRenderFns } from "./SfContentPages.vue?vue&type=template&id=3c73cce2&"
import script from "./SfContentPages.vue?vue&type=script&lang=js&"
export * from "./SfContentPages.vue?vue&type=script&lang=js&"
import style0 from "./SfContentPages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports